<template>
    <v-app :class="scssLocale">
        <loading-page v-show="this.$store.state.loading" />
        <router-view />
        <notification/>
    </v-app>
</template>

<script>

import LoadingPage from '@/components/LoadingPage'
import Notification from '@/components/Notification'
export default {
    name: 'App',

    components: {
        Notification,
        LoadingPage
    },

    computed: {
        scssLocale () {
            // switch to which scss by current language selected (global.scss)
            return this.$vuetify.lang.current + '-locale'
        }
    }
}
</script>

<style lang="scss">
.version-label {
    font-size: 14px;
    color: white;
    margin: 5px;
}
</style>
